import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import NotifyLayout from 'src/components/layouts/NotifyLayout';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import { updateMenu } from 'src/redux/actions/sideLayoutCreator';
import { setPendingOrder } from 'src/redux/actions/webSocketCreator';

const mapStateToProps = ({ userState: { isAgent }, webSocketState: { accountApprove, accountConfigure, order, hasNewOrder } }: IStoreState) => ({
  isAgent,
  approveCount: accountApprove || 0,
  needConfigureCount: accountConfigure || 0,
  orderCount: order || 0,
  hasNewOrder,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    updateMenu: (pathName: string) => dispatch(updateMenu(pathName)),
    setNewOrder: (order: number, hasNewOrder: boolean) => dispatch(setPendingOrder(order, hasNewOrder)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotifyLayout);



// WEBPACK FOOTER //
// ./src/containers/NotifyLayout.ts